import { useState } from "react";
import { computeNumerology } from "@/lib/api";
import { Sparkles } from "lucide-react";

const LABELS = {
  life_path: { title: "Life Path", deva: "जीवन पथ", note: "From your date of birth." },
  destiny: { title: "Destiny / Expression", deva: "भाग्यांक", note: "From the full name." },
  soul_urge: { title: "Soul Urge", deva: "अंतरांक", note: "From the vowels of the name." },
  personality: { title: "Personality", deva: "व्यक्तित्व", note: "From the consonants of the name." },
};

export default function NumerologyCalculator() {
  const [name, setName] = useState("");
  const [birth, setBirth] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      setResult(await computeNumerology({ name, birth_date: birth }));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-line bg-[var(--surface-alt)]/40 p-6 md:p-8">
      <p className="overline-label mb-2">Instant reading</p>
      <h3 className="mb-1 font-serif-latin text-2xl text-ink">Numerology Calculator</h3>
      <p className="mb-5 text-sm text-ink-3">A simple Pythagorean reading for reflection — not a prediction of outcomes.</p>
      <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1.5 block text-sm text-ink-2">Full name</label>
          <input data-testid="numerology-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Arjuna" className="w-full border border-line bg-parchment px-4 py-2.5 text-ink focus:border-saffron focus:outline-none" />
        </div>
        <div>
          <label className="mb-1.5 block text-sm text-ink-2">Date of birth</label>
          <input data-testid="numerology-date" type="date" value={birth} onChange={(e) => setBirth(e.target.value)} className="w-full border border-line bg-parchment px-4 py-2.5 text-ink focus:border-saffron focus:outline-none" />
        </div>
        <div className="sm:col-span-2">
          <button data-testid="numerology-submit" disabled={busy || (!name && !birth)} className="inline-flex items-center gap-2 bg-[var(--saffron)] px-7 py-3 font-medium text-white transition-colors hover:bg-[var(--saffron-dark)] disabled:opacity-50">
            <Sparkles className="h-4 w-4" /> {busy ? "Calculating…" : "Calculate"}
          </button>
        </div>
      </form>
      {result && Object.keys(result.numbers).length > 0 && (
        <div className="mt-8 grid gap-5 sm:grid-cols-2" data-testid="numerology-result">
          {Object.entries(result.interpretations).map(([key, val]) => (
            <div key={key} className="flex items-start gap-4 border border-line bg-surface p-5">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-[var(--gold)] font-serif-latin text-xl text-gold">{val.number}</span>
              <div>
                <p className="font-deva text-base text-ink">{LABELS[key]?.deva}</p>
                <p className="font-serif-latin text-lg text-ink-2">{LABELS[key]?.title}</p>
                <p className="mt-1 text-sm leading-relaxed text-ink-2">{val.meaning}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
